import ScrollLayout from './ScrollLayout';
export default ScrollLayout;
